import { UserPasswordRepository } from "@/domain/repository/user-password-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class InitDoctorPasswordSettingUsecase {
  constructor(private readonly userPasswordRepo: UserPasswordRepository) {}

  async execute(token: string, newPassword: string): Promise<SATResult<void, SATError>> {
    return this.userPasswordRepo.initPasswordByAccountSetupToken(
      token.trim(),
      newPassword,
    );
  }
}
